"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createErrorLog = exports.exception = exports.request = exports.context = exports.setUser = exports.init = void 0;
const library_error_1 = require("@vroskus/library-error");
const lodash_1 = __importDefault(require("lodash"));
const utils_1 = require("./utils");
const init = ({ enabled, integrations, logOutput, Sentry, }, config) => {
    if (enabled) {
        const preparedConfig = Object.assign(Object.assign({ enableTracing: true }, config), { integrations: [
                ...integrations,
                ...(config.integrations || []),
            ] });
        Sentry.init(preparedConfig);
    }
    if (logOutput !== null) {
        console.warn('ErrorLog on');
    }
};
exports.init = init;
const setUser = ({ enabled, logOutput, Sentry, }, params) => {
    if (enabled) {
        Sentry.setUser(params);
    }
    if (logOutput === 'full') {
        console.warn('ErrorLog user: ', params);
    }
};
exports.setUser = setUser;
const context = ({ enabled, logOutput, Sentry, }, message, data) => {
    const preparedData = (0, utils_1.prapareContextData)(data);
    if (enabled) {
        Sentry.addBreadcrumb({
            data: preparedData,
            message,
        });
    }
    if (logOutput === 'full') {
        console.warn('ErrorLog context: ', message, preparedData);
    }
};
exports.context = context;
const request = ({ enabled, logOutput, Sentry, }, req) => {
    const requestId = lodash_1.default.get(req, 'id');
    const user = lodash_1.default.get(req, 'user');
    const { method, originalUrl, } = req;
    if (enabled) {
        Sentry.setExtra('Method', method);
        Sentry.setExtra('Route', originalUrl);
        Sentry.setExtra('Body', JSON.stringify(req.body, undefined, 2));
        Sentry.setExtra('Params', JSON.stringify(req.params, undefined, 2));
        if (requestId) {
            Sentry.setExtra('RequestId', requestId);
        }
        if (user) {
            Sentry.setUser(user);
        }
    }
    if (logOutput === 'full') {
        console.warn('ErrorLog request: ', {
            Body: req.body,
            Method: req.method,
            RequestId: requestId,
            Route: req.originalUrl,
            User: user,
        });
    }
    const params = {
        name: `${method} ${originalUrl}`,
        op: 'http.request',
    };
    return Sentry.startTransaction(params);
};
exports.request = request;
const exception = ({ enabled, logOutput, Sentry, }, error, levelOverride) => {
    let data = lodash_1.default.get(error, 'data');
    let key = lodash_1.default.get(error, 'key');
    const level = levelOverride || lodash_1.default.get(error, 'level', 'error');
    const { config, response, } = error;
    const { message, } = error;
    let { name, } = error;
    if (config && response) {
        data = {
            requestData: config.data,
            requestHeaders: config.headers,
            responseData: response.data,
            responseHeaders: response.headers,
            route: `${config.method.toUpperCase()} ${config.baseURL || ''}${config.url}`,
            status: response.status,
        };
        const dataKey = lodash_1.default.get(response, 'data.key');
        key = dataKey || library_error_1.BaseErrorKey.responseError;
        const foundMessage = lodash_1.default.get(response, 'data.message', message);
        name = `${key}: ${foundMessage}`;
    }
    let preparedData;
    if (data) {
        preparedData = (0, utils_1.prapareContextData)(data);
    }
    if (enabled) {
        Sentry.withScope((scope) => __awaiter(void 0, void 0, void 0, function* () {
            if (data) {
                scope.addBreadcrumb({
                    data: preparedData,
                    message: 'Error data',
                });
            }
            if (key) {
                scope.setTag('error.key', key);
            }
            if (level) {
                scope.setLevel(level);
            }
            Sentry.captureException(error);
        }));
    }
    if (logOutput !== null) {
        console.error('ErrorLog error context: ', {
            data: preparedData,
            key,
            level,
            message,
            name,
        });
        console.error('ErrorLog error: ', error);
    }
};
exports.exception = exception;
const transaction = ({ logOutput, Sentry, }, params) => {
    if (logOutput !== null) {
        console.info('ErrorLog transaction: ', params);
    }
    return Sentry.startTransaction(params);
};
const setTransactionData = (tr, params) => {
    lodash_1.default.forEach(params, (value, key) => tr.setData(key, value));
};
const createErrorLog = (Sentry, integrations) => {
    const instance = {
        enabled: true,
        integrations,
        logOutput: null,
        Sentry,
    };
    const ErrorLog = {
        context: (message, data) => (0, exports.context)(instance, message, data),
        exception: (error, levelOverride) => (0, exports.exception)(instance, error, levelOverride),
        finishTransaction: (tr, data) => {
            if (data) {
                setTransactionData(tr, data);
            }
            tr.finish();
        },
        init: (config, enabledEnvironments, enabledLogOutputEnvironments) => {
            instance.enabled = (0, utils_1.isEnabledEnvironment)(config.environment, enabledEnvironments);
            if (enabledLogOutputEnvironments
                && typeof enabledLogOutputEnvironments === 'object'
                && config.environment in enabledLogOutputEnvironments) {
                instance.logOutput = enabledLogOutputEnvironments[config.environment];
            }
            (0, exports.init)(instance, config);
        },
        request: (req) => (0, exports.request)(instance, req),
        setTransactionData: (tr, data) => setTransactionData(tr, data),
        setUser: (params) => (0, exports.setUser)(instance, params),
        transaction: (params) => transaction(instance, params),
    };
    return ErrorLog;
};
exports.createErrorLog = createErrorLog;
